import React from 'react'
import PropTypes from 'prop-types'

const Cell = ({ time, title, start, end, id, days, style }) => (
  <div className="rt-timebar__cell" style={time.toStyleLeftAndWidth(start, end)}>
    {title}
    {/* {id == 'months' ? (
      <div className="rt-timebar__row_days" style={style}>
        {days.map(cell => {
          // console.log(cell, days)
          return (
            <div className="rt-timebar__cell" style={time.toStyleLeftAndWidth(start, end)}>
              {new Date(cell || "").getDate()}
            </div>
          )
        })}
      </div>
    ) : null} */}
  </div>
)

Cell.propTypes = {
  time: PropTypes.shape({}),
  title: PropTypes.string.isRequired,
  start: PropTypes.instanceOf(Date).isRequired,
  end: PropTypes.instanceOf(Date).isRequired,
}

export default Cell
